import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { Link } from "react-router-dom";

// Shops & Establishment Act forms for whichever state is currently selected
// on the Compliance page - reads the "SHOPS" bucket of the exact same
// `forms` object (from getComplianceFormsByState(selectedState)) PT/LWF/MW/
// LLF's cards already read in Compliances.jsx, so it refreshes on state
// change the same way, at the same time, with no fetch of its own. Only the
// selected state's forms are ever passed in - other states' forms never
// reach this component at all.
//
// Mirrors the PT/LWF/MW/LLF cards' own rule exactly: Compliances.jsx only
// renders this component at all when the selected state actually has SHOPS
// forms (see the `forms.SHOPS?.length` check there), the same way those
// cards only exist for compliance types present in `forms` - so there is no
// "0 forms" case to handle here, and no empty-state card/message.
const ShopsEstablishment = ({ forms, stateId, stateName }) => {
    const title = `Shops & Est Act - ${stateName || ""}`;

    return (
        <div className="row">
            <div className="col-lg-4 col-md col-sm mb-3">
                <div className="card h-100 shadow-sm">
                    <div className="card-header d-flex justify-content-between fw-bold bg-primary text-white">
                        {title}

                        <Tooltip title={title}>
                            <InfoOutlinedIcon className="cursor-pointer" />
                        </Tooltip>
                    </div>

                    <div className="card-body">
                        {forms.map((f) => (
                            <div
                                key={f.id}
                                className="d-flex justify-content-between align-items-start"
                            >
                                <Link
                                    to="generate"
                                    state={{
                                        form: "shops-establishment",
                                        type: "SHOPS",
                                        label: f.form_name,
                                        state: stateId,
                                        formId: f.id,
                                        filters: f.filters,
                                    }}
                                    className="d-flex justify-content-between text-decoration-none flex-grow-1"
                                >
                                    <span>{f.form_name}</span>
                                </Link>

                                <StarBorderIcon fontSize="small" className="text-muted ms-2" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShopsEstablishment;
